import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  createSMSTemplate,
  fetchSMSTemplateCategories,
  fetchVideoTemplates,
  createTestSMS
} from "../actions/index";
import SMSTemplatesForm from "./SMSTemplatesForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";

class SMSTemplatesNewInline extends Component {
  static propTypes = {
    createSMSTemplate: PropTypes.func.isRequired,
    handleUpdateSMSId: PropTypes.func.isRequired,
    fetchSMSTemplateCategories: PropTypes.func.isRequired,
    fetchVideoTemplates: PropTypes.func.isRequired,
    createTestSMS: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    categories: PropTypes.array
  };

  componentDidMount() {
    this.props.fetchSMSTemplateCategories();
    this.props.fetchVideoTemplates();
  }

  sendTestSMS(state) {
    this.props
      .createTestSMS(state)
      .then(response => {
        if (response.payload.status == 200) {
          toastr.success("Test SMS Sent!");
        }
      });
  }

  onSubmit(state) {
    this.props
      .createSMSTemplate(state)
      .then(response => {
        if (response.payload !== undefined) {
          this.props.handleUpdateSMSId(response.payload.data.data.id);
        }
      });
  }

  render() {
    const { categories, videoTemplates } = this.props;
    let body =
      "<p>Hi&nbsp;&nbsp;{{FIRST_NAME}},</p> <p>&nbsp;</p> <p>&nbsp;{{AGENT_EMAIL_SIGNATURE}}</p>";
    if (categories === undefined || videoTemplates === undefined || !categories.data || !videoTemplates.data) {
      return (
        <div className="vertical-center">
          <CSSTransitionGroup
            transitionName="spinner"
            transitionAppear={true}
            transitionAppearTimeout={500}
          >
            <i className="fa fa-refresh fa-4x fa-spin" />
          </CSSTransitionGroup>
        </div>
      );
    }
    return (
      <div className="m-b-40">
        <SMSTemplatesForm
          handleSubmit={this.onSubmit.bind(this)}
          mode="new"
          match={this.props.match}
          categories={categories.data}
          videoTemplates={videoTemplates.data}
          handleSendTestSMS={this.sendTestSMS.bind(this)}
          body={body}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { categories: state.smsTemplateCategories.all, videoTemplates: state.videoTemplates.all };
}

export default connect(
  mapStateToProps,
  { createSMSTemplate, fetchSMSTemplateCategories, createTestSMS, fetchVideoTemplates }
)(SMSTemplatesNewInline);
